import { sharedData } from '../../../models/shared_data'
import React from 'react'
import cartData from '../../cart/models/cart';
import { CurFormatComponent } from '../../shared/cur_format/cur_format.component';

export class StickyHeader extends React.Component {
  constructor(props) {
    super(props)
    this.isActive = this.isActive.bind(this)
    sharedData.subject
      .subscribe(()=> {
        this.forceUpdate()
        this.handleScroll(null)
      })
    cartData.subject
      .subscribe(()=> {
        this.forceUpdate()
        this.handleScroll(null)
      })
    this.handleScroll = this.handleScroll.bind(this);

    this.state = {
      scrolTop: 0
    }

   }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll(null)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(e) {
    this.setState({
      scrollTop: window.pageYOffset || document.documentElement.scrollTop
    })
  }

  isActive() {
    return ''
  }

  showMenu() {
    return this.state.scrollTop > 100 && window.innerWidth > 800
  }

  render() {
    const count = cartData.cartTotalItems()
    const sum = cartData.sum()
    const cl = `header-sticky header-sticky--${sharedData.data.site_params.site_menu_style}`

    if(this.showMenu() && count > 0)
      return (
        <div className={cl}>
          <div className="container header-sticky-wrapper">
            <div className="header-sticky-cart">

              <div className="header-sticky-cart__count">
                <span>В корзине</span>
                &nbsp;
                <strong>{ count }</strong>
                &nbsp;

              </div>
              <div className="header-sticky-cart__total">
               <span>на сумму</span>
               &nbsp;
              <CurFormatComponent type="strong" price={ sum }/>
              </div>
              <a href="/cart" className="btn btn--red">Оформить заказ</a>

            </div>

          </div>

        </div>
      )
    return null

  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/shared/header/sticky.component.jsx